// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder {
  cursor: pointer;

  background-color: var(--t-colors-blue-50);
  border: 1px solid var(--t-colors-blue-300);

  border-radius: 4px;
}

.placeholder::before,
.placeholder::after {
  color: var(--t-colors-blue-600);
  font-weight: bold;
}

.placeholder::before {
  content: '{{';
}

.placeholder::after {
  content: '}}';
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/Placeholder/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf,yCAAyC;EACzC,0CAA0C;;EAE1C,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".placeholder {\n  cursor: pointer;\n\n  background-color: var(--t-colors-blue-50);\n  border: 1px solid var(--t-colors-blue-300);\n\n  border-radius: 4px;\n}\n\n.placeholder::before,\n.placeholder::after {\n  color: var(--t-colors-blue-600);\n  font-weight: bold;\n}\n\n.placeholder::before {\n  content: '{{';\n}\n\n.placeholder::after {\n  content: '}}';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
